module.exports = __webpack_public_path__ + "img/cycle_purple.b5bac670.svg";